import { Currencies } from '../types'

const CURRENCIES: Currencies = {
  money: {
    key: 'money',
    name: 'Money',
    description: 'The root of all evil.',
    color: 'warning',
    icon: '💰'
  },
  energy: {
    key: 'energy',
    name: 'Energy',
    description: 'The fuel of life.',
    color: 'success',
    icon: '⚡'
  },
  stoke: {
    key: 'stoke',
    name: 'Stoke',
    description: 'The essence of surfing.',
    color: 'primary',
    icon: '🤙'
  },
  skill: {
    key: 'skill',
    name: 'Surf Skill',
    description: 'Your overall surfing prowess.',
    color: 'primary',
    icon: '🏄'
  },
  crit_probability: {
    key: 'crit_probability',
    name: 'Criticality Probability',
    description: 'Probability of critical maneuvers',
    color: 'primary',
    icon: '%🔥'
  },
  crit_multiplier: {
    key: 'crit_multiplier',
    name: 'Critical Multiplier',
    description: 'Multiplier of critical maneuvers',
    color: 'primary',
    icon: '🔥'
  }
}
export default CURRENCIES
